import React, { useState, useEffect, useRef, useContext } from "react";
import DynamicIcon from "../../components/dynamicicon";
import { Link, useNavigate, useParams } from "react-router-dom";
import * as Constants from "../../constants";
import { ShareContext } from "../../context/ShareContext";
import BackLoader from "../../components/backloader";
import JisButton from "../../components/controls/jisButton";
import CaseSearch from "../../components/core/case_search";
import moment from "moment";
import { Padding } from "@mui/icons-material";
import CustomSearchSortHeader from "../../components/core/CustomSearchSortHeader";
import wordicon from "../../assets/ms_word.png";
import excelicon from "../../assets/ms_excel.png";
import pdficon from "../../assets/pdf.png";
import JisTabButton from "../../components/controls/jisTabButton";
import JisDialogForm from "../../components/formdialog";
import Pagenated from "../../components/pagenated";

function CfoSwearingSheriff() {
  const { activePage, token, profile, frequentData, setIsExpired, setAlert } =
    useContext(ShareContext);

  const [docs, setDocs] = useState([]);
  const [cases, setCases] = useState([]);
  const [refs, setRefs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [casetype, setCaseType] = useState("litigation");
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(Constants.PAGESIZE);
  const [isSearch, setIsSearch] = useState(false);
  const [search, setSearch] = useState({});
  const [err, setErr] = useState("");
  const [isSchedule, setIsSchedule] = useState(false);
  const [schedule, setSchedule] = useState({});
  const [count, setCount] = useState(0);

  const onPagePick = (pick) => {
    setPageIndex(pick.id - 1);
  };

  const [tab, setTab] = useState("pending");

  const navigate = useNavigate();
  useEffect(() => {
    if (pageIndex >= 0) {
      if (search != null && Object.keys(search).length > 0) {
        onSearch(search);
      }
    } else {
      onLoad();
    }
  }, [pageIndex, pageSize, tab, search]);
  // useEffect(() => {
  //   onLoad();
  // }, []);

  // useEffect(() => {
  //   if (search.length == 0) {
  //     onLoad();
  //   } else {
  //     onSearch(search);
  //   }
  // }, [pageIndex, pageSize, search]);

  const onLoad = async () => {
    //for account registration

    var url = `${Constants.apiUrl}/filing/eswearing-sheriff-cfo-cases/${tab}/${pageIndex}/${pageSize}`;

    try {
      setLoading(true);
      const resp = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json, text/plain",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          caseTitle: "",
          caseNumber: "",
          fromDate: "",
          toDate: "",
          filingtype: "all",
          caseprocess: "all",
          caseTypeId: "",
          caseCategoryId: "",
        }),
      });

      const data = await resp.json();
      if (data.code == 0) {
      }
      setLoading(false);
      console.log(data);
      if (data.code === 0) {
        setCases(data.items);
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        alert(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const onView = (item) => {
    navigate(`/prepare-document/${item.id}/cfo`);
  };

  const onSearch = async (sear) => {
    setSearch(sear);
    setLoading(true);
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/filing/eswearing-sheriff-cfo-cases/${tab}/${pageIndex}/${pageSize}`,
        {
          method: "POST",
          body: JSON.stringify(sear),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code == 0) {
        //update the field
        setCases(data.items);
        if (pageIndex == 0) setCount(data.totalCount);
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };
  const onSelectSchedule = (doc) => {
    setIsSchedule(true);
    console.log(doc);

    setSchedule({ ...schedule, doc });
  };
  const onSaveSchedule = (e) => {
    e.preventDefault();
    console.log(schedule);
    var sch = {
      docid: schedule?.doc.id,
      zoomLink: schedule.zoom,
      scheduledBy: profile.username,
      scheduleDate: schedule.date + " " + schedule.time,
    };

    const uploadurl = `${Constants.apiUrl}/filing/e-swearing/schedule/${schedule.doc.id}`;
    const formData = new FormData();

    // Sending the FormData using fetch
    setLoading(true);
    fetch(uploadurl, {
      method: "POST",
      body: JSON.stringify(sch),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setLoading(false);
        if (data.code == 0) {
          //saved already
          //first upldate the row and show dialog box
          //setCases(cases.map(i => i.docupload[0].id === schedule.doc.id ? {...i, zoomLink:sch.zoomLink, schedule:sch.scheduleDate} : i));
          setCases((prevCases) =>
            prevCases.map((i) => {
              if (i.id === schedule.doc.id) {
                return {
                  ...i,
                  schedule: sch.scheduleDate,
                  zoomLink: sch.zoomLink,
                };
              }
              return i;
            }),
          );
          setSchedule({});

          setAlert({
            open: true,
            title: "Schedule an Appointment",
            subtitle: "Meeting Schedule is successful",
          });
          setIsSchedule(false);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setLoading(false);
      });
  };

  const onChangeTab = (t) => {
    setTab(t);
    setPageIndex(0);
  };

  const onDirectSearch = (sear) => {
    setSearch(sear);
    setIsSearch(true);
    setPageIndex(0);
  };

  return (
    <div>
      <div>
        {/* <CaseSearch onSearch={onSearch} frequentData={frequentData} /> */}
        <CustomSearchSortHeader
          onSearch={onDirectSearch}
          frequentData={frequentData}
        />

        <div className="tab_body">
          <div className="exportdiv">
            <img
              src={wordicon}
              // onClick={() => onExport("word")}
              style={{ cursor: "pointer" }}
            />
            <img
              src={excelicon}
              // onClick={() => onExport("excel")}
              style={{ cursor: "pointer" }}
            />
            <img
              src={pdficon}
              // onClick={() => onExport("pdf")}
              style={{ cursor: "pointer" }}
            />
          </div>

          <div style={{ marginBottom: 24 }} className="tab_section ">
            <JisTabButton
              isActive={tab == "pending"}
              title="Pending Cases"
              isRoleBased={false}
              onClick={() => onChangeTab("pending")}
            />
            <JisTabButton
              isActive={tab == "scheduled"}
              title="Scheduled Cases"
              isRoleBased={false}
              onClick={() => onChangeTab("scheduled")}
            />
            <JisTabButton
              isActive={tab == "completed"}
              title="Commissioned"
              isRoleBased={false}
              onClick={() => onChangeTab("completed")}
            />
          </div>

          <div className="table">
            <div class="section-cases">
              <span>E-Swearing Cases</span>
            </div>
            <div className="table-wrapper">
              <table class="case-table">
                <thead>
                  <tr>
                    {/* <th className="col-id">ID</th> */}

                    <th className="col-title">Suit Number</th>
                    <th className="col-title">Case Title</th>
                    <th>
                      {tab === "completed" ? "Date Created" : "Schedule Date"}
                    </th>
                    {tab === "completed" && <th>Type</th>}
                    {tab === "completed" && <th>Commissioned Date</th>}

                    <th>Time</th>
                    {tab !== "completed" && <th className="col-title">Zoom Link</th>}
                    {tab === "pending" && <th className="col-medium">Schedule</th>}
                    <th>{tab === "completed" ? "View Document" : "Actions"}</th>
                  </tr>
                </thead>
                <tbody>
                  {cases?.map((item, id) => {
                    return (
                      <tr key={id}>
                        {/*  <td>{item.id}</td> */}
                        <td
                          style={{
                            backgroundColor: `${
                              Constants.getItemById(
                                frequentData?.casecategories,
                                item.case.caseCategoryId,
                              )?.colour
                            }`,
                          }}
                        >
                          {" "}
                          {item.case.caseNumber ?? item.case.referenceNumber}
                        </td>
                        <td style={{ maxWidth: "360px" }}>
                          {item.case.caseTitle || "N/A"}
                        </td>

                        <td
                          className={
                            item.schedule != null
                              ? "date-time"
                              : "date-time pends"
                          }
                        >
                          {tab === "completed" &&
                            (item.case.assignedOn
                              ? moment(item.case.assignedOn).format(
                                  "D MMM, YYYY",
                                )
                              : "N/A")}
                          {tab === "pending" && "N/A"}
                          {tab === "scheduled" &&
                            (item.schedule != null
                              ? moment(item.schedule).format("D MMM, YYYY")
                              : "N/A")}
                        </td>
                        {tab === "completed" && (
                          <td
                            style={{
                              textTransform: "capitalize",
                            }}
                          >
                            {item.caseType || "N/A"}
                          </td>
                        )}
                        {tab === "completed" && (
                          <td>
                            {item.completeDate
                              ? moment(item.completeDate).format(
                                  "Do MMMM, YYYY",
                                )
                              : "N/A"}
                          </td>
                        )}
                        <td
                          className={
                            item.schedule != null
                              ? "date-time"
                              : "date-time pends"
                          }
                        >
                          {tab === "completed" &&
                            (item.completeDate
                              ? moment(item.completeDate).format("h:mm a")
                              : "N/A")}
                          {tab === "pending" && "N/A"}
                          {tab === "scheduled" &&
                            (item.schedule != null
                              ? moment(item.schedule).format("h:mm a")
                              : "N/A")}
                        </td>
                        {tab !== "completed" && (
                          <td
                            className={
                              item.schedule != null ? "zoom" : "zoom pends"
                            }
                          >
                            {item.zoomLink != null ? (
                              <a
                                href={item.zoomLink}
                                target="_blank"
                                rel="noreferrer"
                                className="cfo-text-link"
                              >
                                Zoom Lin
                              </a>
                            ) : (
                              "N/A"
                            )}
                          </td>
                        )}
                        {tab === "pending" && (
                          <td className="cfo-swearing-btn-cell">
                            <JisButton
                              variant="plain"
                              onClick={() => onSelectSchedule(item)}
                            >
                              Schedule
                            </JisButton>
                          </td>
                        )}
                        {tab === "completed" ? (
                          <td>
                            <div
                              className="selected"
                              onClick={() => onView(item)}
                            >
                              View Documents
                            </div>
                          </td>
                        ) : (
                          <td className="cfo-swearing-btn-cell">
                            {" "}
                            <JisButton
                              variant="plain"
                              className="black"
                              onClick={() => onView(item)}
                            >
                              View Documents Attached
                            </JisButton>
                          </td>
                        )}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            {cases?.length > 0 && (
              <Pagenated
                onChangePageSize={(k) => setPageSize(k)}
                size={pageSize}
                total={count}
                maxPage={20}
                onPick={onPagePick}
              />
            )}
          </div>
        </div>
      </div>
      <BackLoader open={loading} />
      {/* {isSchedule && (
        <div className={"preview open"}>
          <div style={{ Padding: 16 }}>
            <div className="heading">
              <h2>e-Swearing Appointment </h2>
            </div>
            <div className="input-group">
              <label>
                Zoom Link <span className="required">*</span>{" "}
              </label>
              <div className="input-wrapper">
                <DynamicIcon iname="group" />
                <input
                  placeholder="Zoom Link"
                  required={true}
                  type="text"
                  value={schedule.zoom}
                  onChange={(e) =>
                    setSchedule({ ...schedule, zoom: e.target.value })
                  }
                />
              </div>
            </div>

            <div className="input-group">
              <label>
                Zoom meeting date <span className="required">*</span>{" "}
              </label>
              <div className="input-wrapper">
                <DynamicIcon iname="group" />
                <input
                  placeholder="Schedule Date"
                  type="date"
                  required={true}
                  value={schedule.date}
                  onChange={(e) =>
                    setSchedule({ ...schedule, date: e.target.value })
                  }
                />
              </div>
            </div>

            <div className="input-group">
              <label>
                Zoom meeting time <span className="required">*</span>{" "}
              </label>
              <div className="input-wrapper">
                <DynamicIcon iname="group" />
                <input
                  type="time"
                  placeholder="Zoom meeting time"
                  value={schedule.time}
                  onChange={(e) =>
                    setSchedule({ ...schedule, time: e.target.value })
                  }
                />
              </div>
            </div>

            <div className="btngr">
              <JisButton
                icon="close"
                variant={"outline"}
                onClick={() => setIsSchedule(false)}
              >
                Cancel
              </JisButton>
              <JisButton icon="check_circle" onClick={onSaveSchedule}>
                Schedule Appointment
              </JisButton>
            </div>
          </div>
        </div>
      )} */}
      {isSchedule && (
        <JisDialogForm
          title="Appointment Details"
          onClose={() => setIsSchedule(false)}
        >
          <form onSubmit={onSaveSchedule}>

         
          <div>
            <div className="input-group">
              <label> Zoom Link</label>
              <div className="input-wrapper">
                <DynamicIcon iname="monitor-play" />
                <input
                  type="url"
                  placeholder="Zoom Link"
                  value={schedule.zoom}
                  onChange={(e) =>
                    setSchedule({ ...schedule, zoom: e.target.value })
                  }
                />
              </div>
            </div>

            <div className="input-group">
              <label> Zoom meeting date</label>
              <div className="input-wrapper">
                <input
                  type="date"
                  placeholder="Zoom meeting date"
                  value={schedule.date}
                  onChange={(e) =>
                    setSchedule({ ...schedule, date: e.target.value })
                  }
                />
              </div>
            </div>

            <div className="input-group">
              <label> Zoom meeting time</label>
              <div className="input-wrapper">
                <input
                  type="time"
                  placeholder="Zoom meeting time"
                  value={schedule.time}
                  onChange={(e) =>
                    setSchedule({ ...schedule, time: e.target.value })
                  }
                />
              </div>
            </div>

            <div>
              <div className="schedule_btn_wrapper">
                <button
                  variant={"outline"}
                  onClick={() => setIsSchedule(false)}
                >
                  Cancel
                </button>
                <button type="submit">Schedule Appointment</button>
              </div>
            </div>
          </div>
           </form>
        </JisDialogForm>
      )}
    </div>
  );
}

export default CfoSwearingSheriff;
